import Moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ButtonLoader from '../../Elements/Button/button';
import ThumbnailGrid from '../../Elements/Thumbnail/thumbnail';
import InComponentLoader from '../../Elements/Loader/componentloader';
import '../../../assets/css/siicex-usuario.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import React, { Component } from 'react';
import axios from 'axios';
import {API_URL,BASE_URL_CMS,BASE_URL_RECURSOS,BASE_URL_FRONTEND} from '../../../constants';
import Error from '../../Error/error';
import {stateToHTML} from 'draft-js-export-html';
import {DropDownList} from '../../Elements/Select/dropdown';
import {DropDownListChild} from '../../Elements/Select/dropdown';
import cookie from 'react-cookies';
import ImageUploader from 'react-images-upload';
import {toBase64} from '../../../functions';
import {updateValueInJson, showModalPageClass, hideModalPageClass} from '../../../functions';

import {  EditorState } from 'draft-js';
import {ValidateState} from '../../../functions';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import BulletinIcon from '@material-ui/icons/EventNote';
import ContenidoIcon from '@material-ui/icons/LineStyle';
import ImagenIcon from '@material-ui/icons/Image';
import VideoIcon from '@material-ui/icons/VideoLibrary';
import InfoIcon from '@material-ui/icons/HelpOutline';
import DocumentIcon from '@material-ui/icons/AttachFile';
import { DropDownListMaster } from '../../Elements/Select/dropdownChild';
import { DropDownListChildMaster } from '../../Elements/Select/dropdownChild';
import Checkbox from '@material-ui/core/Checkbox';
import ReactPlayer from 'react-player'
import CKEditor from 'ckeditor4-react';
import ModalMultimedia from '../../Partials/ModalMultimedia';
import TagInput from '../../Elements/TagInput/TagInput';
import { validateImageFile, fetchImageDimensions, fetchImagePesoMaximo } from './utils';

let config = {
    height : '600px',
    width :'100%',
	addCss: '.divImagenConBajada img{width: 100% !important;}',
	toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		'/',
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'Outdent', 'blocks', 'align', 'bidi', 'paragraph','iframe' ,'Anchor'] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
	removeButtons : 'Save,NewPage,Preview,Print,Templates,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Subscript,Superscript,Strike,CopyFormatting,JustifyRight,BidiLtr,BidiRtl,Language,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,FontSize,Font,Maximize,ShowBlocks,About,Intent',
	stylesSet : [
		{ name: 'Enlace único', element: 'a', attributes: { 'class': 'enlaceUnico' } },
		{ name: 'Botón rojo', element: 'a', attributes: { 'class': 'btnIrAlPortal' } },
		{ name: 'Lista 2 Columnas', element: 'ul', attributes: { 'class': 'ListaEn2Columnas' } },
		{ name: '1 Imagen Grande / Bajada', element: 'section',attributes: { 'class': 'divImagenConBajada' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
		{ name: '2 Imagenes Pequeñas / Bajada', element: 'section',attributes: { 'class': 'divImagenMedianas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
		{ name: '3 Imagenes Chiquitas / Bajada', element: 'section',attributes: { 'class': 'divImagenChiquitas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} }
	],
	div_wrapTable : true,
	extraAllowedContent: 'section class iframe style video embed',
	allowedContent : true,
	image: {toolbar: [ 'imageTextAlternative' ]},
	extraPlugins : 'embed, iframe',
	embed_provider : '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback} ',
	skin : 'kama'
}

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}>
        <Box p={3}>{children}</Box>
      </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
};

let countCaracteresResumenPdf = 0;

export default class add_recurso extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            resource:{},
            response: [],
            error: [],
            sectors: [],
            key: 0,
            editorState: EditorState.createEmpty(),
            editorStateHTML : '' ,
            editorStateB: EditorState.createEmpty(),
            editorStateHTMLB : '' ,
            security: cookie.load('user'),
            roles: [],
            numeroTab: 0,
            HTML: '<span>&nbsp</span>',
            fieldReturnMultimedia:"",
            imagesToSelect: false,
            selectedImage: false,
            selectedFile: false,
            imageLimitDimension: null,
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.handleInputChangeDate = this.handleInputChangeDate.bind(this);
        this.onEditorChangeEdit = this.onEditorChangeEdit.bind(this);
        this.onEditorChangeEditResumen = this.onEditorChangeEditResumen.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.asignDefaultImage = this.asignDefaultImage.bind(this);
        this.getResponse = this.getResponse.bind(this);
        this.handleProductoChange = this.handleProductoChange.bind(this);

        this.currentImagePage = 1;
        
        // const limiteMbImagen = 1; 
        // this.imageLimitePesoBytes = limiteMbImagen * 1024 * 1024;
        
        this.VALIDAR_IMAGEN_AL_GRABAR = true;
    }

    onEditorChangeEdit(evt) {
        if (evt.editor !== undefined){
          let html = evt.editor.getData();
          let copyResource = JSON.parse(JSON.stringify(this.state.resource));
          copyResource["sContenido"] = html;
          this.setState({
            resource: copyResource,
            HTML: html
          }, ()=> {});
        }
    }

    onEditorChangeEditResumen(evt) {
        let html = evt.editor.getData();
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        let caracteres = html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').replace(/&\w+;/g ,'X').replace(/^\s*/g, '').replace(/\s*$/g, '').length;

        copyResource["recu_ResumenPdf"] = html;
        document.getElementById("count-caracteres").innerHTML = caracteres;
        countCaracteresResumenPdf = caracteres;

        this.setState({
            resource: copyResource
        });
    }

    GetSectors(){
        const urlBase  = `${API_URL}`
        axios.get(urlBase + 'MasterUX/6').then(response => response.data)
        .then((data) => {
            this.setState({ sectors: data.result});
        }).catch(error => {
        });
    }

    handleChangeTab = (event, newValue) => {
        this.setState({numeroTab: newValue});
    };


    handleInputChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        if(event.target.id === "sArchivoNombre"){
            let texto = event.target.value.toLocaleLowerCase();
            let textoOri = event.target.value;
            let letras = "abcdefghijklmnopqrstuvwxyz0123456789-.";
            let _valueO = '';

            for (var i = 0; i < texto.length; i++) {
              if (letras.indexOf(texto[i]) != -1) {
                _valueO += textoOri[i];
              }
            }

            event.target.value = _valueO;
            copyResource['sArchivoNombre'] = _valueO;
        }
        else if(event.target.id === "recu_SeoUrlCanonical"){
            let texto = event.target.value.toLocaleLowerCase();
            let textoOri = event.target.value;
            let letras = "abcdefghijklmnopqrstuvwxyz0123456789-";
            let _valueO = '';

            for (var i = 0; i < texto.length; i++) {
              if (letras.indexOf(texto[i]) != -1) {
                _valueO += textoOri[i];
              }
            }

            event.target.value = _valueO;
            copyResource['recu_SeoUrlCanonical'] = _valueO;
        }
        else{
           copyResource[target.name] = value;
        }

        // If we're modifying title, modify friendly url too
        if(event.target.id === "sTitulo"){
            // Modify share url
            let _value = event.target.value.toLocaleLowerCase();
            [  // Search these values and replace 'em
                {val: " ", replace: "-"},
                {val: "á", replace: "a"},
                {val: "é", replace: "e"},
                {val: "í", replace: "i"},
                {val: "ó", replace: "o"},
                {val: "ú", replace: "u"},
                {val: "|", replace: ""},
                {val: "°", replace: ""},
                {val: "!", replace: ""},
                {val: "#", replace: ""},
                {val: "$", replace: ""},
                {val: "%", replace: ""},
                {val: "&", replace: ""},
                {val: "/", replace: ""},
                {val: "(", replace: ""},
                {val: ")", replace: ""},
                {val: "=", replace: ""},
                {val: "'", replace: ""},
                {val: "?", replace: ""},
                {val: "¡", replace: ""},
                {val: "¿", replace: ""},
                {val: "´", replace: ""},
                {val: "¨", replace: ""},
                {val: "+", replace: ""},
                {val: "*", replace: ""},
                {val: "{", replace: ""},
                {val: "}", replace: ""},
                {val: "[", replace: ""},
                {val: "]", replace: ""},
                {val: ";", replace: ""},
                {val: ",", replace: ""},
                {val: ":", replace: ""},
                {val: ">", replace: ""},
                {val: "<", replace: ""},
                {val: "`", replace: ""},
                {val: "^", replace: ""}
            ].forEach((letter) => {
                while(_value.indexOf(letter.val)!=-1) _value = _value.replace(letter.val, letter.replace);
            });

            copyResource['sUrlCanonical'] = _value;
            copyResource['sArchivoNombre'] = _value;
        }

        if(event.target.name === "nTipoRecursoCodigo"){
            this.changeUIByTipoDoc(event.target.value.value)
        }

        if(target.name == "nSectorCodigo")
        {
          copyResource["listLineaProducto"] = [];
          copyResource["listPartida"] = [];
        }

        this.setState({ resource: copyResource });
    }

    changeTagInput(name, val){
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource[name] = val;
        this.setState({ resource: copyResource }, () => console.log(this.state.resource));
    }

handleProductoChange(event) {
        const selectedOptions = event.target.value;
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        let productoDescriptions = null;
        if (selectedOptions && selectedOptions.length > 0) {
            productoDescriptions = selectedOptions.map(option => option.label).join(',');
        }
        
        copyResource['sProducto'] = productoDescriptions;
        this.setState({ resource: copyResource });
    }

    changeUIByTipoDoc(codigo){
      if(codigo === 14){
                document.getElementById('simple-tab-3').style.display = 'block';
                document.getElementById('simple-tab-4').style.display = 'block';
                document.getElementById('simple-tab-5').style.display = 'none';
                document.getElementById('simple-tab-6').style.display = 'block';
                document.getElementById('simple-tab-7').style.display = 'none';
                document.getElementById('div-sresumen').style.display = 'block';

                document.getElementById('tab1-notimail').style.display = 'block';
                document.getElementById('tab1-notipush').style.display = 'block';
                document.getElementById('tab1-portada').style.display = 'block';
                document.getElementById('tab1-noticia').style.display = 'block';

            }
            else{
                document.getElementById('simple-tab-3').style.display = 'none';
                document.getElementById('simple-tab-4').style.display = 'none';
                document.getElementById('simple-tab-5').style.display = 'block';
                document.getElementById('simple-tab-6').style.display = 'none';
                document.getElementById('simple-tab-7').style.display = 'block';
                document.getElementById('div-sresumen').style.display = 'none';

                document.getElementById('tab1-notimail').style.display = 'none';
                document.getElementById('tab1-notipush').style.display = 'none';
                document.getElementById('tab1-portada').style.display = 'none';
                document.getElementById('tab1-noticia').style.display = 'none';
            }
    }

    async componentDidMount(){

        await fetchImageDimensions().then(limits => {this.setState({ imageLimitDimension: limits });});
        await fetchImagePesoMaximo().then(maxMB => {this.setState({ imageLimitePesoBytes: maxMB * 1024 * 1024 });});

        this.GetSectors();
        this.getImages();

        var key = this.props.location.state.key;
        const url = `${API_URL}ResourceUX/${key}/1`;
        var roles = [];
        roles = this.state.security.cRolesxUsuario.length > 0 ? this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; }) : [];

        axios.get(url).then(response => response.data)
        .then((data) => {

            let copyResource = JSON.parse(JSON.stringify(data.result));
            copyResource["cEstado"] = "R";
            copyResource["bActivo"] = true;
            copyResource["recu_NotificarPorPush"] = false;
            copyResource["recu_NotificarPorCorreo"] = false;
            copyResource["recu_SeoSeguirEnlace"] = false;
            copyResource["recu_SeoMostrarMotores"] = false;
            copyResource["nUbicacionCodigo"] = 1;
            copyResource["Recu_PalabrasClave"] = '';
            copyResource["nTipoRecursoCodigo"] = 15;

            this.setState({
                roles: roles,
                resource: copyResource,
                response: data,
                error: data.Error
            });

            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
            document.getElementById('simple-tab-3').style.display = 'none';
            document.getElementById('simple-tab-4').style.display = 'none';
            document.getElementById('simple-tab-5').style.display = 'none';
            document.getElementById('simple-tab-6').style.display = 'none';
            document.getElementById('simple-tab-7').style.display = 'none';
            document.getElementById('div-sresumen').style.display = 'none';

            this.changeUIByTipoDoc("15")

        })
        .catch(error => {
            document.querySelector('.loader').classList.add('loader--hide');
            toast.error("¡Error al consultar items [add-recurso]!");
        });


    }

    handleClickCancel(e){
        this.props.history.push({
            pathname: '/recurso'
        });
    }

    async asignDefaultImage (codigo){
        const url = `${API_URL}CategoryUX/ObtenerCategoriaRecurso/${codigo}`;
        try{
            const res = await axios.get(url);
            if(res.data.result){
                const result = res.data.result;
                const defaultImg = result.imagenPorDefecto;
                this.state.resource.sImagen = defaultImg;
            }
        } catch(err){
            this.state.resource.sImagen = "";
        }
    }

    callFunctionButton = async (event) => {
        event.preventDefault();
        let _isOk = true;

        if (this.VALIDAR_IMAGEN_AL_GRABAR && this.state.selectedImage) {
            const val = await validateImageFile(
                this.state.selectedImage,
                this.state.imageLimitDimension,
                this.state.imageLimitePesoBytes
            );

            if (!val.ok) {
                toast.error(val.message);
                this.setState({ loading: false });
                return;
            }
        }
        
        let tipoRecurso = this.state.resource.nTipoRecursoCodigo;

        if(ValidateState(this.state.resource, 'nTipoRecursoCodigo', '0')){  toast.error('Error en Validación: Seleccione al menos un Tipo de Recurso.'); _isOk = false; }
        if(ValidateState(this.state.resource, 'cRec_Id', '0')){  toast.error('Error en Validación: Seleccione al menos una Categoría de Recurso.'); _isOk = false; }
        if(ValidateState(this.state.resource, 'sTitulo', '')){  toast.error('Error en Validación: Ingrese un Título.'); _isOk = false;  }
        if(tipoRecurso.value == 14){
            if(ValidateState(this.state.resource, 'sResumen', '')){  toast.error('Error en Validación: Ingrese un Resumen.'); _isOk = false; }
        }
        // if(tipoRecurso.value != 14)
            {
            // if(ValidateState(this.state.resource, 'recu_ResumenPdf', '')){  toast.error('Error en Validación: Ingrese un Resumen del pdf.'); _isOk = false; }
            if(countCaracteresResumenPdf > 5000){toast.error('Error en Validación: Resumen del PDF supera el limite de los 5000 caracteres.'); _isOk = false;}
        }
        if(ValidateState(this.state.resource, 'nUbicacionCodigo', '1')){  toast.error('Error en Validación: Seleccione al menos un Mercado.'); _isOk = false; }
        if(ValidateState(this.state.resource, 'nSectorCodigo', '0')){  toast.error('Error en Validación: Seleccione al menos un Sector.'); _isOk = false; }

        // if(this.state.resource.sEnlaceDocumento && this.state.resource.sEnlaceDocumento !== ''){
        //     //evaluar si existe imagen

        //     if(!this.state.resource.sImagen || this.state.resource.sImagen === ""){
        //         if((typeof this.state.resource.nTipoRecursoCodigo === 'object' && this.state.resource.nTipoRecursoCodigo.value === 14)){

        //         }else{
        //             await this.asignDefaultImage(this.state.resource.nTipoRecursoCodigo.value);
        //         }
        //     }
        // }

if (!this.state.resource.sImagen || this.state.resource.sImagen === "") {
            // Obtenemos el código del tipo de recurso (maneja si es objeto o valor)
            let typeCode = this.state.resource.nTipoRecursoCodigo.value 
                           ? this.state.resource.nTipoRecursoCodigo.value 
                           : this.state.resource.nTipoRecursoCodigo;
                           
            // Tu función asignDefaultImage ya actualiza this.state.resource.sImagen
            await this.asignDefaultImage(typeCode);
        }
        

        // if(ValidateState(this.state.resource, 'Lpro_Id', '0')){  toast.error('Error en Validación: Seleccione al menos una linea de producción.'); _isOk = false; }

        // If there are any error, abort
        if(!_isOk){
            return;
        }
        if(tipoRecurso.value == 14){
            if(ValidateState(this.state.resource, 'sContenido', '')){  toast.warning('Alerta : no ha ingresado contenido.');}
        }

        const {history: {push}} = this.props;
        const url = `${API_URL}ResourceUX/`;
        var dataForm = this.state.resource;

        this.setState({
            loading:true
        });

        // Get form data
        var sAutor    = this.state.resource.sAutor ;
        var sOrigen    = this.state.resource.sOrigen;

        var nUbicacionCodigo    = this.state.resource.nUbicacionCodigo;
        var nSectorCodigo       = this.state.resource.nSectorCodigo;
        var listPartida         = this.state.resource.listPartida;
        var listLineaProducto   = this.state.resource.listLineaProducto;
        var sProducto   = this.state.resource.sProducto;

        var ubicacion           = nUbicacionCodigo.map(v => v.value);
        var sector              = nSectorCodigo.map(v => v.value);
        var partida             = listPartida ? listPartida.map(v => v.value) : listPartida;
        var sectorNames         = nSectorCodigo.map(v => v.label);
        var lineaProducto       = listLineaProducto ? listLineaProducto.map(v => v.value) : [];

        dataForm    = updateValueInJson(dataForm,'listLineaProducto', String(lineaProducto));
        dataForm    = updateValueInJson(dataForm,'nUsuarioCreacion', this.state.security.nUsuCodigo);
        dataForm    = updateValueInJson(dataForm,'listPais', String(ubicacion));
        dataForm    = updateValueInJson(dataForm,'listSector', String(sector));
        dataForm    = updateValueInJson(dataForm,'listPartida', String((partida===null?"":partida)));
        dataForm    = updateValueInJson(dataForm,'sAutor', sAutor.value ? sAutor.value : '')
        dataForm    = updateValueInJson(dataForm,'sOrigen', sOrigen.value ? sOrigen.value : '')
        dataForm    = updateValueInJson(dataForm,'sProducto', sProducto ? sProducto : '')

        // dataForm    = updateValueInJson(dataForm,'Lpro_Id', 0);
        dataForm    = updateValueInJson(dataForm,'nLineaProductoCodigo', 0);
        dataForm    = updateValueInJson(dataForm,'nUbicacionCodigo', 0);
        dataForm    = updateValueInJson(dataForm,'nSectorCodigo', 0);
        dataForm    = updateValueInJson(dataForm,'nTipoRecursoCodigo', (this.state.resource.nTipoRecursoCodigo.value?this.state.resource.nTipoRecursoCodigo.value:this.state.resource.nTipoRecursoCodigo));
        dataForm    = updateValueInJson(dataForm,'sSector', String(sectorNames));
        dataForm    = updateValueInJson(dataForm,'cEstado', (this.state.resource.cEstado.value ? this.state.resource.cEstado.value : this.state.resource.cEstado));
        dataForm    = updateValueInJson(dataForm,'bActivo', (this.state.resource.bActivo.value ? this.state.resource.bActivo.value : this.state.resource.bActivo));
        dataForm    = updateValueInJson(dataForm,'recu_NotificarPorPush',   (this.state.resource.recu_NotificarPorPush.value ? this.state.resource.recu_NotificarPorPush.value : this.state.resource.recu_NotificarPorPush));
        dataForm    = updateValueInJson(dataForm,'recu_NotificarPorCorreo', (this.state.resource.recu_NotificarPorCorreo.value ? this.state.resource.recu_NotificarPorCorreo.value : this.state.resource.recu_NotificarPorCorreo));
        dataForm    = updateValueInJson(dataForm,'recu_SeoSeguirEnlace',   (this.state.resource.recu_SeoSeguirEnlace.value ? this.state.resource.recu_SeoSeguirEnlace.value : this.state.resource.recu_SeoSeguirEnlace));
        dataForm    = updateValueInJson(dataForm,'recu_SeoMostrarMotores', (this.state.resource.recu_SeoMostrarMotores.value ? this.state.resource.recu_SeoMostrarMotores.value : this.state.resource.recu_SeoMostrarMotores));
        dataForm    = updateValueInJson(dataForm,'cRec_Id', (this.state.resource.cRec_Id.value ? this.state.resource.cRec_Id.value : this.state.resource.cRec_Id));
        dataForm    = updateValueInJson(dataForm,'sUsuario', this.state.security.sUsuNombre + ' ' + this.state.security.sUsuApellidoPaterno);

        const formData = JSON.stringify(dataForm);
        axios.post(
            url,
            JSON.stringify(formData),
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }
        ).then( data => {
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
            if (data.data.isSucess){
                toast.success('Recurso registrado correctamente. \n Se redireccionará al listado');
                setTimeout(() => {
                    //window.location.href = BASE_URL_CMS + "/recurso"
                    this.props.history.push({
                        pathname: '/recurso',
                    });
                }, 1000);


            }else{
                this.setState({loading:false});
                toast.error('No se pudo registrar el Recurso. \r');
            }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
        });
    }

    onEditorStateChange = (event) => {
        let html = event.editor.getData();
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        copyResource["sContenido"] = html;

        this.setState({
            resource: copyResource
        });
    };

    handleInputChangeDate(control){
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource['dFechaPublicacion'] = Moment(control).format();

         this.setState({
             resource: copyResource
        });
    }

    onDrop = async (file_container, flag) => {
        if (file_container.length < 1) return;

        const file = file_container[0];
        if (!file) {
            this.setState({ [flag]: false });
            return;
        }

        if (flag === 'selectedImage') {
            const result = await validateImageFile(
                file, 
                this.state.imageLimitDimension, 
                this.state.imageLimitePesoBytes
            );

            if (!result.ok) {
                toast.error(result.message);
                this.setState({ selectedImage: false });
                return;
            }
        }

        toBase64(file).catch(e => {
            if (flag === 'selectedImage') {
                toast.error("Ocurrió un error al analizar la imagen, por favor seleccione otra");
            } else {
                toast.error("Ocurrió un error al analizar el archivo, por favor seleccione otro");
            }
            this.setState({ [flag]: false }); 
        }).then(data => {
            let _tmp = {};
            _tmp[flag] = file;
            _tmp[flag].base64 = data;
            this.setState(_tmp);
        });
    }


    useStyles = makeStyles(theme => ({
        root: {
          flexGrow: 1,
          backgroundColor: theme.palette.background.paper,
        },
    }));

    getImages(page=1){
      const urlBase  = `${API_URL}`
      axios.get(urlBase + `FileUX/0/${page}/all/all/all`).then(response => response.data)
      .then((data) => {
        this.currentImagePage = page
        this.setState({ imagesToSelect: data.result});
      }).catch(error => {
        console.error(error);
      });
    }


    selectImage = (img_obj) => {
      // Set this.state properties
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sImagen', img_obj.sArchivoRuta)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', img_obj.nArchivoCodigo)
      this.setState({resource: _tmp}, () => {
        document.getElementById("thumbnail-modal-close").click();
      });
    }

    unSelectImage = () => {
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sImagen', null)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', null)
      this.setState({resource: _tmp});
    }


    uploadImage = async () => {
        let _file = this.state.selectedImage;

        if (!_file) {
            toast.error("No hay ninguna imagen seleccionada para subir.");
            return;
        }

        const r = await validateImageFile(
            _file,
            this.state.imageLimitDimension,
            this.state.imageLimitePesoBytes
        );

        if (!r.ok) {
            toast.error(r.message);
            return;
        }

        let formData = {};
        let _filename = _file.name;

        formData.sArchivoNombre = _filename;
        formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16";
        formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".") + 1, _filename.length);
        formData.sArchivoTipo = "imagenes";
        formData.sCategoriaArchivo = "";
        formData.sArchivoData = _file.base64;
        formData.nCodigoUsuario = this.state.security.nUsuCodigo;

        toast.info("Por favor espere mientras la imagen es procesada");

        axios.post((API_URL + `FileUX/`),
            ("'" + JSON.stringify(formData) + "'"),
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Accept': 'application/json'
                }
            }
        ).then(data => {
            toast.success("La imagen ha sido subida correctamente");

            let _tmp = updateValueInJson({}, 'sImagen', data.data.result.sArchivoRuta);
            _tmp = updateValueInJson(_tmp, 'nImagenCodigo', data.data.result.nArchivoCodigo);

            this.setState({ resource: { ...this.state.resource, ..._tmp } });
        }).catch((error) => {
            console.error(error);
            toast.error('Error al subir la imagen');
        });
    }


  uploadFile = async () => {
    let _isOk = true;

    if (ValidateState(this.state.resource, 'sArchivoNombre', '')) { 
        toast.error('Error en Validación: Debe ingresar el nombre del documento.'); 
        _isOk = false; 
    }

    let _file = this.state.selectedFile;

    if (!_file) {
        toast.error("Debe seleccionar un archivo PDF.");
        return;
    }

    if (!_isOk) { return; }

    let formData = {};
    let _filename = _file.name;

    formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16";
    formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".") + 1, _filename.length);
    formData.sArchivoNombre = `${this.state.resource.sArchivoNombre}.${formData.sArchivoExtension}`;
    formData.sArchivoTipo = "documentos";
    formData.sCategoriaArchivo = "";
    formData.sArchivoData = _file.base64;
    formData.nCodigoUsuario = this.state.security.nUsuCodigo;

    toast.info("Por favor espere mientras el documento es procesado, esto puede tomar hasta un minuto...");

    axios.post((API_URL + `FileUX/`),
        ("'" + JSON.stringify(formData) + "'"),
        {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json'
            }
        }
    ).then(data => {
        toast.success("El documento ha sido subido correctamente");

        let _tmp = updateValueInJson({}, 'nArchivoCodigo', data.data.result.nArchivoCodigo);
        _tmp = updateValueInJson(_tmp, 'sEnlaceDocumento', data.data.result.sArchivoRuta);
        _tmp = updateValueInJson(_tmp, 'sArchivoNombre', data.data.result.sArchivoNombre);
        _tmp = updateValueInJson(_tmp, 'sArchivoNombreOld', data.data.result.sArchivoNombre);

        this.setState({ resource: { ...this.state.resource, ..._tmp } });
    }).catch((error) => {
        console.error(error);
        toast.error('Error al subir el archivo');
    });
}

    paginationTable(){
      // Get data
      let data = this.state.imagesToSelect.length!=0 ? this.state.imagesToSelect : false;
      if(!data){
        data = this.state.imagesToSelect;
        if(!data || data.length==0) return;
      }

      // Pagination calcs
      let totalPages = data[0].totalPages;
      let options = false;
      options = [];

      // Inicio button
      if(totalPages>2) options.push(<span id={"pagination-inicio"} key={"pagination-inicio"} onClick={() => this.getImages(1)}>Inicio </span>);
      // Index buttons
      for(let index=1; index<(totalPages+1); index++){
        if(index>10 && index%10!=0) continue;
        options.push(
          <span id={"pagination-"+index}
            key={"pagination-link-"+index}
            onClick={() => this.getImages(index)}
            className={index===this.currentImagePage?"active":""}>
              {index}
          </span>
        );
      }
      // Fin button
      if(totalPages>2) options.push(<span id={"pagination-fin"} key={"pagination-fin"} onClick={() => this.getImages(totalPages)}>Fin </span>);

      return (
        <div className="pagination" key={"pagination"}>
          {options}
        </div>
      );
    }

    letrasNumeroBlur = (e) => {
        let texto = e.target.value.toLowerCase();
        let textoOri = e.target.value;
        let result = "";
        let letras = "abcdefghijklmnñopqrstuvwxyz0123456789-.";

        for (var i = 0; i < texto.length; i++) {
          if (letras.indexOf(texto[i]) != -1) {
            result += textoOri[i];
          }
        }
        e.target.value = result;
        this.handleInputChange(e);
    }

    letrasCanonicalBlur = (e) => {
        let texto = e.target.value.toLowerCase();
        let textoOri = e.target.value;
        let result = "";
        let letras = "abcdefghijklmnopqrstuvwxyz0123456789-";

        for (var i = 0; i < texto.length; i++) {
          if (letras.indexOf(texto[i]) != -1) {
            result += textoOri[i];
          }
        }
        e.target.value = result;
        this.handleInputChange(e);
    }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;

        if(fieldReturn!== ""){

            resource[fieldReturn] = urlSeleccionada;

            this.setState({resource:resource, fieldReturnMultimedia:""});
        }

        hideModalPageClass("divGestorArchivosMultimedia");
    }

    showModalMultimedia = (clase = "", campo = "") => {
        this.setState({fieldReturnMultimedia:campo});
        showModalPageClass(clase);
    }

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });
        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        const { editorState } = this.state;
        //console.log(this.state);

        return (
                (this.state.response.statusCode === 200) ?
                (
                    <div id="detailBody" className="Site-content" >
                        <div className="loader"></div>
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >
                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="dFechaPublicacion" name="dFechaPublicacion" defaultValue={this.state.resource.dFechaPublicacion} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={this.state.resource.nUsuarioModificacion} />
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                    <div className="content-option">
                                        <div className="row ">
                                            <div className="col-md-12">
                                                <AppBar position="static" color="default" >
                                                    <Tabs   value={this.state.numeroTab} onChange={this.handleChangeTab}
                                                            scrollButtons="auto"
                                                            aria-label="icon label tabs example"
                                                            variant="fullWidth"
                                                            indicatorColor="secondary"
                                                            textColor="secondary">
                                                                <Tab icon={<BulletinIcon />} label="General" {...a11yProps(0)} />
                                                                <Tab icon={<ImagenIcon />} label="Imagen" {...a11yProps(1)} />
                                                                <Tab icon={<DocumentIcon />} label="Documento" {...a11yProps(2)} />
                                                                <Tab icon={<VideoIcon />} label="Video" {...a11yProps(3)} />
                                                                <Tab icon={<ContenidoIcon />} label="Contenido" {...a11yProps(4)} />
                                                                <Tab icon={<ContenidoIcon />} label="Resumen" {...a11yProps(5)} />
                                                                <Tab icon={<InfoIcon />} label="Informacion" {...a11yProps(6)} />
                                                                <Tab icon={<ImagenIcon />} label="SEO" {...a11yProps(7)} />
                                                    </Tabs>
                                                </AppBar>
                                                <TabPanel value={this.state.numeroTab} index={0}>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="nRecursoCodigo"><strong>Código</strong></label>
                                                                    <input type="text" readOnly name="nRecursoCodigo" onChange={this.handleInputChange} id="nRecursoCodigo" defaultValue={this.state.resource.nRecursoCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                                </div>

                                                                <div className="form-group" style={{display:'none'}} >
                                                                    <label htmlFor="nTipoRecursoCodigo"><strong>Tipo</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownListMaster valor={this.state.resource.nTipoRecursoCodigo} child="Categoria" name="nTipoRecursoCodigo" id="nTipoRecursoCodigo"  onChange={this.handleInputChange} clave={this.state.resource.nTipoRecursoCodigo} componente={"TipoRecurso"} />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="cRec_Id"><strong>Categoría</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownListChildMaster  isMulti={false}  valor={this.state.resource.cRec_Id}  name="CRec_Id" onChange={this.handleInputChange}  parent="TipoRecurso" id="cRec_Id" componente={"Categoria"} />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="sTitulo"><strong>Título</strong></label>
                                                                    <input type="text" name="sTitulo" id="sTitulo" onChange={this.handleInputChange} defaultValue={this.state.resource.sTitulo} className="form-control text-filter__form-control" placeholder="Título" />
                                                                </div>
                                                                <div id='div-sresumen' className="form-group">
                                                                    <label htmlFor="sResumen"><strong>Resumen</strong></label>
                                                                    <input type="text" name="sResumen" id="sResumen" onChange={this.handleInputChange} defaultValue={this.state.resource.sResumen} className="form-control text-filter__form-control" placeholder="Resumen" />
                                                                </div>
                                                                {/* <div className="form-group">
                                                                    <label htmlFor="sOrigen"><strong>Organización</strong></label>
                                                                    <input type="text" name="sOrigen" id="sOrigen" onChange={this.handleInputChange} defaultValue={this.state.resource.sOrigen} className="form-control text-filter__form-control" placeholder="Organización respectivamente" />
                                                                </div> */}

                                                                <div className="form-group">
                                                                    <label htmlFor="sOrigen" className='h6'>
                                                                        <strong>Organización</strong>
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList valor={0} isMulti={false} name="sOrigen" id="sOrigen"  onChange={this.handleInputChange} clave={this.state.resource.sOrigen}
                                                                            componente={"Recurso_Organizacion"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {/* <div className="form-group">
                                                                    <label htmlFor="sAutor"><strong>Unidad organizacional</strong></label>
                                                                    <input type="text" name="sAutor" id="sAutor" onChange={this.handleInputChange} defaultValue={this.state.resource.sAutor} className="form-control text-filter__form-control" placeholder="Unidad organizacional" />
                                                                </div> */}
                                                                <div className="form-group">
                                                                    <label htmlFor="sAutor" className='h6'>
                                                                        <strong>Unidad organizacional</strong>
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList valor={0} isMulti={false} name="sAutor" id="sAutor"  onChange={this.handleInputChange} clave={this.state.resource.sAutor}
                                                                            componente={"Recurso_OrganizacionUnidad"}
                                                                        />
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                            <div className="form-group">
                                                                <label htmlFor="nUbicacionCodigo"><strong>Mercado</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownList
                                                                        valor={[{pais_Id:-999}]}
                                                                        isMulti={true}
                                                                        name="nUbicacionCodigo"
                                                                        id="nUbicacionCodigo"
                                                                        onChange={this.handleInputChange}
                                                                        clave={this.state.resource.lResourceCountry}
                                                                        componente={"Ubicacion"}
                                                                    />

                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="nSectorCodigo"><strong>Sector</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownList
                                                                        valorHijo={this.state.resource.lResourceLineaProducto}
                                                                        clave={this.state.resource.lResourceSector}
                                                                        valor={[{nSectorCodigo:-999}]}
                                                                        child={["LineaProducto", "PartidaCascada"]}
                                                                        name="nSectorCodigo"
                                                                        onChange={this.handleInputChange}
                                                                        id="nSectorCodigo" componente={"Sector"}
                                                                        isMulti={true} />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="listPartida"><strong>Partida</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownListChild
                                                                        isMultiple={true}
                                                                        name="listPartida"
                                                                        onChange={this.handleInputChange}
                                                                        parent="Sector"
                                                                        id="listPartida"
                                                                        componente={"PartidaCascada"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="listPartida"><strong>Producto asociado</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownList
                                                                        name="sProducto"
                                                                        id="sProducto"
                                                                        // valor={""}
                                                                        etiqueta={"Producto"}
                                                                        metodo="added"
                                                                        onChange={this.handleProductoChange}
                                                                        componente={"Productos"}
                                                                        isMulti={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="listLineaProducto"><strong>Línea de Producto</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownListChild
                                                                        clave={this.state.resource.listLineaProducto}
                                                                        isMultiple={true}
                                                                        name="listLineaProducto"
                                                                        onChange={this.handleInputChange}
                                                                        parent="Sector"
                                                                        id="listLineaProducto"
                                                                        componente={"LineaProducto"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label ><strong>Fecha de Publicación</strong></label>
                                                                <br/>
                                                                <DatePicker
                                                                    className="form-control text-filter__form-control_date col-md-6"
                                                                    onChange={this.handleInputChangeDate}
                                                                    value={Moment(this.state.resource.dFechaPublicacion).format('dddd DD, MMMM YYYY')}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                                <div className="">
                                                                    <DropDownList
                                                                        filtro={this.state.roles}
                                                                        valor={"R"}
                                                                        etiqueta={"BORRADOR"}
                                                                        metodo="added"
                                                                        name="cEstado"
                                                                        id="cEstado"
                                                                        onChange={this.handleInputChange}
                                                                        clave={this.state.resource.cEstado}
                                                                        componente={"Estado"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="bActivo">
                                                                    <strong>Activo</strong>
                                                                </label>
                                                                <div className="">
                                                                    <DropDownList
                                                                        valor={"true"}
                                                                        etiqueta={"ACTIVO"}
                                                                        metodo="added"
                                                                        name="bActivo"
                                                                        id="bActivo"
                                                                        onChange={this.handleInputChange}
                                                                        clave={this.state.resource.bActivo}
                                                                        componente={"Activo"}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div id='tab1-portada' className="form-group">
                                                                    <label htmlFor="bPortada"><strong>Portada</strong></label>
                                                                    <div className="bPortada">
                                                                        <Checkbox  name="bPortada" id="bPortada" onChange={this.handleInputChange} value={this.state.resource.bPortada} placeholder="Cabecera" />
                                                                    </div>
                                                                </div>
                                                                <div id='tab1-noticia' className="form-group">
                                                                    <label htmlFor="bImportante"><strong>Noticia Banner</strong></label>
                                                                    <div className="bImportante">
                                                                        <Checkbox  name="bImportante" id="bImportante" onChange={this.handleInputChange} value={this.state.resource.bImportante} placeholder="Cabecera" />
                                                                    </div>
                                                                </div>

                                                                <div  id='tab1-notipush' className="form-group">
                                                                    <label htmlFor="recu_NotificarPorPush">
                                                                        <strong>Notificar por push</strong>
                                                                    </label>
                                                                    <div className="recu_NotificarPorPush">
                                                                        <Checkbox
                                                                            name="recu_NotificarPorPush"
                                                                            id="recu_NotificarPorPush"
                                                                            onChange={this.handleInputChange}
                                                                            placeholder="Notificar por push"
                                                                            checked={this.state.resource.recu_NotificarPorPush}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div  id='tab1-notimail' className="form-group">
                                                                    <label htmlFor="recu_NotificarPorCorreo">
                                                                        <strong>Notificar por correo</strong>
                                                                    </label>
                                                                    <div className="recu_NotificarPorCorreo">
                                                                        <Checkbox
                                                                            name="recu_NotificarPorCorreo"
                                                                            id="recu_NotificarPorCorreo"
                                                                            onChange={this.handleInputChange}
                                                                            placeholder="Notificar por push"
                                                                            checked={this.state.resource.recu_NotificarPorCorreo}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="sEnlaceInteres"><strong>Enlace a recursos externos</strong></label>
                                                                    <input type="text" name="sEnlaceInteres" id="sEnlaceInteres" onChange={this.handleInputChange} defaultValue={this.state.resource.sEnlaceInteres} className="form-control text-filter__form-control" placeholder="Enlace a recursos externos" />
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="Recu_PalabrasClave">
                                                                        <strong>Palabras clave</strong>
                                                                    </label>
                                                                    <TagInput
                                                                        name="Recu_PalabrasClave"
                                                                        id="Recu_PalabrasClave"
                                                                        onChange={(val) => this.changeTagInput('Recu_PalabrasClave', val)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={1}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="sTituloImagen"><strong>Título Imagen</strong></label>
                                                                <input type="text" name="sTituloImagen"
                                                                  className="form-control text-filter__form-control ocultar"
                                                                  defaultValue={this.state.resource.sTituloImagen||""}
                                                                  onChange={this.handleInputChange} id="sTituloImagen"
                                                                  style={{padding: "15px"}}
                                                                  placeholder="Título archivo" />
                                                            </div>

                                                            {/* <div className="boletin__filters section__margin-bottom">
                                                                <button
                                                                  type="button" className="btn btn-primary btn-primary__tool"
                                                                  data-toggle="modal" data-target="#thumbnail-modal">
                                                                    {this.state.resource.sImagen?"CAMBIAR":"SELECCIONAR DE SERVIDOR"}
                                                                </button>
                                                            </div> */}
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <ImageUploader
                                                                  imgExtension={['.jpg', '.gif', '.png', '.gif']}
                                                                  accept='.jpg,.gif,.png'
                                                                  onChange={(file) => this.onDrop(file,"selectedImage")}
                                                                  buttonText='Elegir una imagen...'
                                                                  label="Formatos aceptados: JPG - GIF - PNG - GIF"
                                                                  id="Uploader"
                                                                  singleImage={true} withIcon={true}
                                                                  withPreview={true} maxFileSize={5242880}
                                                                />
                                                                <button
                                                                    disabled={!this.state.selectedImage}
                                                                    type="button"
                                                                    className="btn btn-primary btn-primary__tool"
                                                                    onClick={this.uploadImage}
                                                                >
                                                                    SUBIR IMAGEN
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                {!this.state.resource.sImagen
                                                                  ? (<h6>No se ha seleccionado ninguna imagen</h6>)
                                                                  : (
                                                                    <div>
                                                                      <img className="col-md-12"
                                                                        src={BASE_URL_RECURSOS + this.state.resource.sImagen} />
                                                                      <br/><br/>
                                                                      <button
                                                                        type="button" className="btn btn-primary btn-primary__tool"
                                                                        onClick={this.unSelectImage}>
                                                                          Elimina imagen
                                                                      </button>
                                                                    </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={2}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="sArchivoNombre">
                                                                    <strong>Nombre Documento</strong>
                                                                </label>
                                                                <input type="text" name="sArchivoNombre"
                                                                  className="form-control text-filter__form-control"
                                                                  defaultValue={this.state.resource.sArchivoNombre }
                                                                  id="sArchivoNombre"
                                                                  onChange={this.handleInputChange}
                                                                  onBlur={this.letrasNumeroBlur}
                                                                  style={{padding: "15px"}}
                                                                  placeholder="Nombre documento (sin extensión)" />
                                                            </div>
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <strong>Enlace Documento: </strong>&nbsp;
                                                                    {
                                                                      !this.state.resource.sEnlaceDocumento
                                                                      ? "No se ha agregado ningun documento"
                                                                      : (
                                                                        <a id="span-sEnlaceDocumento" target='_blank' href={BASE_URL_RECURSOS+this.state.resource.sEnlaceDocumento}>
                                                                          {BASE_URL_RECURSOS+this.state.resource.sEnlaceDocumento}
                                                                        </a>
                                                                      )
                                                                    }
                                                                </div>
                                                                <br></br>
                                                                <ImageUploader
                                                                  imgExtension={['.doc', 'docx', 'pdf', 'ppt', 'pptx']}
                                                                  accept='.pdf'
                                                                  onChange={(file) => this.onDrop(file,"selectedFile")}
                                                                  buttonText='Click para elegir documento'
                                                                  label="Formato aceptado: PDF"
                                                                  id="Uploader"
                                                                  singleImage={true}
                                                                  withIcon={false}
                                                                  withPreview={false} maxFileSize={15242880}
                                                                />
                                                                <button
                                                                    disabled={!this.state.selectedFile}
                                                                    type="button"
                                                                    className="btn btn-primary btn-primary__tool"
                                                                    onClick={this.uploadFile}
                                                                >
                                                                    Subir imagen
                                                                </button>
                                                                <br/>
                                                                <br/>
                                                                  {/* <strong>Documento: </strong>&nbsp; {this.state.resource.sDescripcionLineaProducto} */}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                          <div className="boletin__filters section__margin-bottom">
                                                            <iframe src= {`https://docs.google.com/gview?url=${BASE_URL_RECURSOS + this.state.resource.sEnlaceDocumento}&embedded=true`}   class="col-md-12"  height="450px"/>
                                                          </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={3}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="sEnlaceVideo"><strong>Enlace Video</strong></label>
                                                                    <input type="text" name="sEnlaceVideo" id="sEnlaceVideo" onChange={this.handleInputChange} defaultValue={this.state.resource.sEnlaceVideo} className="form-control text-filter__form-control" placeholder="Enlace Vídeo" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <ReactPlayer url={this.state.resource.sEnlaceVideo} playing />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={4}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <CKEditor
                                                                    id="sContenido"
                                                                    name="sContenido"
                                                                    config={config}
                                                                    data={this.state.resource.sContenido}
                                                                    onChange={this.onEditorStateChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={5}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <label htmlFor="recu_ResumenPdf"><strong>Máximo 5000 caracteres (<span id='count-caracteres'>0</span> / 5000)</strong></label>
                                                                <CKEditor
                                                                    data={this.state.resource.recu_ResumenPdf}
                                                                    onChange={this.onEditorChangeEditResumen}
                                                                    config={config}
                                                                    id="recu_ResumenPdf"
                                                                    name="recu_ResumenPdf"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={6}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="boletin__filters section__margin-bottom">
                                                            <div className="form-group">
                                                                <label htmlFor="nNumero"><strong>Número Correlativo</strong></label>
                                                                <input type="text" name="nNumero" id="nNumero" readOnly={true} onChange={this.handleInputChange} defaultValue={this.state.resource.nNumero} className="form-control text-filter__form-control" placeholder="Código" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="nVistas"><strong>Número de Vistas</strong></label>
                                                                <input type="text" name="nVistas" id="nVistas" readOnly={true} onChange={this.handleInputChange} defaultValue={this.state.resource.nVistas} className="form-control text-filter__form-control" placeholder="Código" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="nDescargas"><strong>Número de Descargas</strong></label>
                                                                <input type="text" name="nDescargas" id="nDescargas" readOnly={true} onChange={this.handleInputChange} defaultValue={this.state.resource.nDescargas} className="form-control text-filter__form-control" placeholder="Código" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="sUrlCanonical"><strong>URL amigable</strong></label>
                                                                <div style={{whiteSpace: "nowrap", overflowX: "scroll"}}>
                                                                    <label htmlFor="sUrlCanonical">{BASE_URL_FRONTEND+"/noticias/"}</label>
                                                                    <input type="text" name="sUrlCanonical" id="sUrlCanonical" onChange={this.handleInputChange} defaultValue={this.state.resource.sUrlCanonical} className="form-control text-filter__form-control" placeholder="" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <strong><hr/></strong>
                                                            <strong>FECHA DE CREACIÓN:</strong> {this.state.resource.dFechaCreacion}
                                                            <br/>
                                                            <strong>CREADO POR</strong> :
                                                            <br/><br/>
                                                            <strong>FECHA DE MODIFICACIÓN:</strong> {this.state.resource.dFechaModificacion}
                                                            <br/>
                                                            <strong>MODIFICADO POR:</strong>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={7}>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoTitulo"><strong>SEO Título</strong></label>
                                                                    <input type="text" name="recu_SeoTitulo" id="recu_SeoTitulo" onChange={this.handleInputChange} maxLength={70} defaultValue={this.state.resource.recu_SeoTitulo} className="form-control text-filter__form-control" placeholder="SEO Título (70 caracteres)" />
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoDescripcion"><strong>SEO Descripción</strong></label>
                                                                    <textarea name="recu_SeoDescripcion" id="recu_SeoDescripcion" onChange={this.handleInputChange} maxLength={140} defaultValue={this.state.resource.recu_SeoDescripcion} className="form-control text-filter__form-control" placeholder="SEO Descripción (140 caracteres)" style={{height: "100px"}}></textarea>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoUrlCanonical"><strong>SEO Url Canonical</strong></label>
                                                                    <input type="text" name="recu_SeoUrlCanonical" id="recu_SeoUrlCanonical" onBlur={this.letrasCanonicalBlur} onChange={this.handleInputChange} maxLength={1000} defaultValue={this.state.resource.recu_SeoUrlCanonical} className="form-control text-filter__form-control" placeholder="SEO Url canonical" />
                                                                </div>
                                                                <div className="txtFile x-1 relative">
                                                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "recu_SeoImagen")}/>
                                                                    <input type="text" placeholder="SEO Imagen" name='recu_SeoImagen' value={this.state.resource.recu_SeoImagen} maxLength={1000} onChange={this.handleInputChange} className="form-control text-filter__form-control"/>
                                                                </div>
                                                            </div>
                                                            <ModalMultimedia class="divGestorArchivosMultimedia" callback={this.getResponse.bind(this)}/>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoSeguirEnlace">
                                                                        <strong>Seguir enlace</strong></label>
                                                                    <div className="recu_SeoSeguirEnlace">
                                                                        <Checkbox
                                                                            name="recu_SeoSeguirEnlace"
                                                                            id="recu_SeoSeguirEnlace"
                                                                            onChange={this.handleInputChange}
                                                                            //value={this.state.resource.recu_SeoSeguirEnlace}
                                                                            placeholder="Seguir enlace"
                                                                            checked={this.state.resource.recu_SeoSeguirEnlace}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoMostrarMotores">
                                                                        <strong>Mostrar motores</strong></label>
                                                                    <div className="recu_SeoMostrarMotores">
                                                                        <Checkbox
                                                                            name="recu_SeoMostrarMotores"
                                                                            id="recu_SeoMostrarMotores"
                                                                            onChange={this.handleInputChange}
                                                                            //value={this.state.resource.recu_SeoMostrarMotores}
                                                                            placeholder="Mostrar motores"
                                                                            checked={this.state.resource.recu_SeoMostrarMotores}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoScript"><strong>SEO Script</strong></label>
                                                                    <textarea name="recu_SeoScript" id="recu_SeoScript" onChange={this.handleInputChange} maxLength={1000} defaultValue={this.state.resource.recu_SeoScript} className="form-control text-filter__form-control" placeholder="Pegue aquí su código javascript" style={{height: "127px"}}></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5">
                                                <button type="button" onClick={(event) => this.handleClickCancel(event)} className="btn btn-default btn-primary__submit">Cancelar</button>
                                                &nbsp;
                                                <ButtonLoader text="GUARDAR" textProcessing="PROCESANDO..." loading={this.state.loading} callFunctionButton={(e) => this.callFunctionButton(e)}></ButtonLoader>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                        </form>

                        {/* Modals */}
                        <div className="modal fade" id="thumbnail-modal" tabIndex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                          <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>

                              <div className="modal-body modal-subscription__body">
                                <p className="modal-subscription__title">Imagenes</p>

                                <p className="modal-subscription__info">
                                  <div className="recursos__wrapper-table">
                                    {/* Content */}
                                    {this.state.imagesToSelect
                                      ? <ThumbnailGrid
                                          selectImage={this.selectImage}
                                          img_links={this.state.imagesToSelect}
                                          changePage={this.getImages}
                                          sizeX={"150px"} sizeY={"150px"} />
                                      : <InComponentLoader show={true} message={"Se están obteniendo las imagenes, por favor espere un momento"} />
                                    }
                                  </div>
                                </p>
                                {this.paginationTable()}
                              </div>

                              <div className="modal-footer">
                                <button id="thumbnail-modal-close" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                  <i className="fas fa-close fa-sm"></i> &nbsp;
                                  <span>Cerrar</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                )
                :
                (
                    <Error StatusCode="500" StatusMessage="Error"></Error>
                )
                );
    }
}